module.exports = __webpack_public_path__ + "static/547528530.76dd491e.jpg";